<template>
    <v-container fluid class="px-0 py-0 logs">
        <template v-if="dLog && dCfg">
            <div class="logs-summary">
                <span>时间：{{ dLog.checkTime | formatDatetime }}</span>
                <span v-if="dLog.address">地址：
                    <a v-if="dLog.lbsUrl" :href="dLog.lbsUrl" target="view-address">地图中查看</a>
                    <template v-else>{{ dLog.address }}</template>
                </span>
            </div>
            <ul>
                <li class="groups" v-for="g in dCfg.opts" :key="g.id">
                    <h5>{{ g.name }}</h5>
                    <ul class="opts">
                        <li v-for="opt in g.opts" :key="opt.id">
                            <v-chip v-if="dLog.logs[opt.id] === undefined" outline>{{ opt.name }}</v-chip>
                            <v-chip v-else-if="opt.type == 2"
                                :color="(dLog.logs[opt.id] && dLog.logs[opt.id].passed) ? 'green' : 'red'" outline>
                                {{ opt.name + ':' + (dLog.logs[opt.id] ? dLog.logs[opt.id].val : '') }}
                            </v-chip>
                            <v-chip v-else :color="(dLog.logs[opt.id] && (dLog.logs[opt.id] == 1)) ? 'green' : 'red'"
                                outline>
                                {{ opt.name }}
                            </v-chip>
                        </li>
                    </ul>
                </li>
            </ul>
            <div class="logs-photos">
                <!--<p>点击图片可以放大查看全图</p>-->
                <v-layout v-if="dLog.photos">
                    <v-flex class="logs-photo xs6 sm3 d-flex" v-for="photo in dLog.photos" :key="photo">
                        <v-card flat tile class="d-flex">
                            <v-img aspect-ratio="1" :src="photo" @click="onImagePreview(photo)" />
                        </v-card>
                    </v-flex>
                </v-layout>
            </div>
        </template>
    </v-container>
</template>
<script>
export default {
    name: "vehicle-check-log",
    props: {
        log: Object,
        cfg: Object
    },
    data() {
        return {
            dLog: null,
            dCfg: null
        };
    },
    watch: {
        cfg() {
            this.init();
        },
        log() {
            this.init();
        }
    },
    methods: {
        onImagePreview() {
            //this.$dialog.img('车辆拍照', { src: src });
        },
        parseRegex(cfg, log) {
            if (!log || !log.logs) { return; }
            let logs = log.logs;
            for (let g of cfg.opts) {
                for (let opt of g.opts) {
                    if (opt.type != 2) { continue; }
                    let tmp = logs[opt.id];
                    if (tmp === undefined) { continue; }
                    if (!opt.normalRegex) {
                        continue;
                    }
                    tmp = { val: tmp + '', passed: true };
                    logs[opt.id] = tmp;
                    if (opt.normalRegex) {
                        let regex = new RegExp(opt.normalRegex);
                        tmp.passed = regex.test(tmp.val);
                    }
                }
            }
        },
        parseAddress(log) {
            //地理位置的转化
            if (log) {
                if (/[0-9.]+\/[0-9.]+/.test(log.address)) {
                    let gps = log.address.split('/'), marker = encodeURIComponent(`coord:${gps[1]},${gps[0]};title:检查位置`);
                    log.lbsUrl = `https://apis.map.qq.com/tools/poimarker?type=0&key=${encodeURIComponent('L2RBZ-34QYU-DPAVE-4LVGC-E4ZJF-5MFBF')}&referer=${encodeURIComponent('云平台')}&marker=${marker}`;
                } else {
                    log.lbsUrl = null;
                }
            }
        },
        init() {
            let self = this, id = self.$route.params._lid || (self.cfg && self.cfg._lid);
            if (id) {
                self.$axios.get(`/home/admin/m/my/tenant/vehicle/check/log/detail/${id}`).then(r => {
                    let cfg = r.data.cfg, log = r.data.message;
                    if (log.checkerSign) {
                        log.checkerSign = `${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/three/check/log/upload/view/checkerSign/${log.checkerSign}?__entity_id=${log.id}`;
                    }
                    log.logs = JSON.parse(log.logs);
                    let photos = log.photos;
                    if (photos) {
                        let urls = [];
                        photos = photos.split(',');
                        for (let p of photos) {
                            urls.push(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/check/log/upload/view/photos/${p}?__entity_id=${log.id}`);
                        }
                        log.photos = urls;
                    }
                    self.parseAddress(log);
                    self.parseRegex(cfg, log);
                    self.dLog = log;
                    self.dCfg = cfg;
                });
                return;
            }
            self.parseAddress(self.dLog);
            self.parseRegex(self.cfg, self.log);
            self.dCfg = self.cfg;
            self.dLog = self.log;
        },

    },
    created() {
        this.init();
    },
};
</script>
<style scoped>
.logs {
    clear: both;
    padding: 8px;
    margin: 8px 0;
}

.logs-summary {
    padding: 8px;
    font-style: italic;
    color: #0068B7;
}

.logs-summary span {
    margin-right: 16px;
}

.logs ul {
    list-style: none;
    margin: 0;
    padding: 0;
}


.logs li h5 {
    font-size: 14px;
    margin: 8px 0;
}

.logs .groups {
    margin: 8px 0;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 8px;
}

.logs ul.opts li {
    display: inline-block;
}

.logs-photos {
    margin: 8px 0;
    border: 1px solid #eee;
    padding: 8px;
    border-radius: 8px;
}

.logs-photo {
    padding: 8px;
}

.logs-photos p {
    color: #888;
    margin: 0;
    padding: 0;
}
</style>